'use strict';

// ---------- Envoltorio WAV mínimo ----------
//
// Duplex.java entrega PCM crudo (16 bits, 8 kHz, mono). Esto le pone el
// encabezado WAV de 44 bytes de siempre para que cualquier reproductor lo
// abra, igual que hacía `ffmpeg -f s16le ... salida.wav` en la versión local.

export function pcm16ToWavBlob(pcmChunks, sampleRate = 8000) {
  const totalBytes = pcmChunks.reduce((n, c) => n + c.byteLength, 0);
  const buffer = new ArrayBuffer(44 + totalBytes);
  const view = new DataView(buffer);

  const writeStr = (offset, str) => {
    for (let i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i));
  };

  writeStr(0, 'RIFF');
  view.setUint32(4, 36 + totalBytes, true);
  writeStr(8, 'WAVE');
  writeStr(12, 'fmt ');
  view.setUint32(16, 16, true); // tamaño del bloque fmt
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, 1, true); // mono
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * 2, true); // byte rate (16 bits mono)
  view.setUint16(32, 2, true); // block align
  view.setUint16(34, 16, true); // bits por muestra
  writeStr(36, 'data');
  view.setUint32(40, totalBytes, true);

  let offset = 44;
  const bytes = new Uint8Array(buffer);
  for (const chunk of pcmChunks) {
    bytes.set(chunk, offset);
    offset += chunk.byteLength;
  }

  return new Blob([buffer], { type: 'audio/wav' });
}
